module.exports = ".alignClose {\n  margin-top: 1em; }\n"